import { type Dispatch, type SetStateAction, useEffect, useState } from 'react'

export const useProductQuantitySelectionControls = ({
  currentVariantUpid,
}: {
  currentVariantUpid?: string
}): {
  quantity: number
  setQuantity: Dispatch<SetStateAction<number>>
} => {
  const [quantity, setQuantity] = useState(1)

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- don't reference, refactor if touched
    setQuantity(1)
  }, [currentVariantUpid])

  return {
    quantity,
    setQuantity,
  }
}
